import generatePseudo from './generate-pseudo';

export default generatePseudo;